import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { config } from 'config';
import { useIsAdmin } from 'hooks/useIsAdmin';

export const AdminRoute = ({ children }: { children: ReactNode }) => {
    const isAdmin = useIsAdmin();
    return isAdmin ? <>{children}</> : <Navigate to={config.routes.commission.overview} replace />;
};
